import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-ad5',
  templateUrl: './ad5.component.html',
  styleUrls: ['./ad5.component.css']
})
export class Ad5Component implements OnInit {

  @Output() stepChangeEvent = new EventEmitter<string>();

  fifthAdForm: FormGroup

  selectedPlan: number

  adPlans = []

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.data.subscribe((data: { adPlans: any})=>{
      this.adPlans = data.adPlans
    })
    this.fifthAdForm = new FormGroup({
      ad_plan_id: new FormControl('', [Validators.required])
    })
  }

  next(){
    this.stepChangeEvent.emit('final-step')
  }

  previous(){
    this.stepChangeEvent.emit('step-4')
  }

  selectPlan(plan: number){
    this.selectedPlan = plan
    this.fifthAdForm.setValue({ad_plan_id: this.selectedPlan})
  }

}
